import firebase from 'firebase/app';
import messaging from 'firebase/messaging'; // eslint-disable-line
import store from '@/stores';
import HTTP from '.';

let isSupported = false;
let msg = { };
if (typeof api_config !== 'undefined') { // eslint-disable-line
  firebase.initializeApp(api_config.firebase); // eslint-disable-line
  isSupported = firebase.messaging.isSupported();
  msg = (isSupported ? firebase.messaging() : { });
}

function getToken() {
  return new Promise((resolve, reject) => {
    msg.getToken().then((token) => {
      if (token) {
        HTTP.defaults.headers.common.FCMToken = token;
        resolve(token);
      }
    })
      .catch(reject);
  });
}

function deleteToken() {
  return new Promise((resolve, reject) => {
    getToken().then((token) => {
      if (token) {
        msg.deleteToken(token)
          .then(resolve)
          .catch(reject);
      } else {
        resolve();
      }
    }).catch(reject);
  });
}

function subscribe() {
  return HTTP.post('/api/currentmember/preferences/notifications/subscribe');
}

function requestPermission(doSubscribe) {
  return new Promise((resolve, reject) => {
    msg.requestPermission().then(() => {
      getToken().then((token) => {
        if (doSubscribe) {
          subscribe()
            .then(resolve)
            .catch(reject); // eslint-disable-next-line
        }
        else {
          resolve(token);
        }
      }).catch(reject);
    }).catch(reject);
  });
}

function validateRequestPermission() {
  HTTP.get('/api/currentmember/preferences/notifications/requestPermission').then((response) => {
    if (response.data.requestPermission) {
      requestPermission(true);
    }
  });
}

if (isSupported) {
  msg.usePublicVapidKey(api_config.firebase.vapId); // eslint-disable-line

  msg.onMessage((payload) => {
    store.commit('alerts/setAlert', { msg: payload.notification.body.replace('\r\n', '<br/>') });
  });

  msg.onTokenRefresh(() => {
    getToken().then((token) => {
      subscribe(token);
    });
  });

  getToken();
}

export default class FCMService {
  static isSupported() {
    return isSupported;
  }

  static deleteToken() {
    return new Promise((resolve, reject) => {
      if (!isSupported) resolve();
      deleteToken()
        .then(resolve)
        .catch(reject);
    });
  }

  static requestPermission(doSubscribe) {
    return new Promise((resolve, reject) => {
      if (!isSupported) resolve();
      requestPermission(doSubscribe)
        .then(resolve)
        .catch(reject);
    });
  }

  static subscribe() {
    return subscribe();
  }

  static validateRequestPermission() {
    if (!isSupported) return;
    validateRequestPermission();
  }
}
